const TextInput = ({attribute, id, placeholder = null, label = null, action = null, type = "text", required = true, checked = false }) => {
    return (
        <div>
            {label && <label htmlFor= {id} className="block text-lg font-medium text-gray-700">
                {label} {required === true && "*"}
            </label>}
            
            <input
                type={type}
                id={id}
                value={attribute}
                onChange={action}
                placeholder={placeholder}
                required={required}
                checked={checked}
                className="mt-1 block w-full px-3 py-2 text-lg border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
            />
        </div>
    )
}
export default TextInput